<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg12>
        <npo-table
        :headers="tableHeaders"
        :associateNpoEnabled="false"
        ></npo-table>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import npoTable from '@/components/npos/ComponentNpoTable'
import { tablePaginationMixin } from '@/mixins/tablePaginationMixin'
import { statusColor } from '@/mixins/statusColor'

export default {
  mixins: [tablePaginationMixin, statusColor],
  watch: {
    dialog (val) {
      val || this.closeModal()
    }
  },
  components: {
    npoTable
  },
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.tableHeaders.filter((item) => item.value !== 'action')
    }
  },
  data () {
    return {
      // Npos table
      tableHeaders: [
        {
          text: 'Npo',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Contact',
          align: 'left',
          sortable: true,
          value: 'contacts'
        },
        { text: 'Intervention area', value: 'area', sortable: true },
        { text: 'Campaigns', value: 'campaigns', sortable: false },
        { text: 'Registration status', value: 'registration_status_name' },
        { text: 'Status', value: 'status_name' },
        { text: 'City', value: 'city' },
        { text: 'Actions', value: 'action', sortable: false }
      ]
    }
  }
}
</script>
